// @ts-nocheck

import { match as MatchStateUtils } from '..';
import { __ } from '../../i18n/l10n';
import type { ScoreboardProps, SecondariesScoreType } from '../../states/scoreboards';

export const computeSecondaryScores = (scores: Array<string>): SecondariesScoreType => {
  const finalScores = [];

  // For handball, the TAB scores are added in the second index of setScores
  // ex: 10:16 - 17:11 at end of regl time, the next time will do 10:16 - 17:12
  // If OT then TAB, we first have 10:16 - 17:11 - 3:3 during OT then 10:16 - 20:14 when TAB starts
  if (scores.length > 1) {
    finalScores.unshift({
      label: __('!short:HalfTime'),
      score: scores[0].split(':'),
    });
  }
  if (scores.length > 2) {
    finalScores.unshift({
      label: __('!short:RegularTime'),
      score: [MatchStateUtils.computeScore(scores, 0, 2), MatchStateUtils.computeScore(scores, 1, 2)],
    });
  }

  return finalScores;
};

export default ({
  sportId,
  matchId,
  period,
  periodName,
  setScores,
  competitor1Name,
  competitor1Flag,
  competitor2Name,
  competitor2Flag,
}: unknown): ScoreboardProps => {
  let scores = null;

  if (setScores && setScores !== '') {
    scores = setScores.split(' - ');
  }

  return {
    matchId,
    period: periodName || MatchStateUtils.statusMatchBySport(sportId, period),
    competitors: [
      {
        name: competitor1Name,
        flag: competitor1Flag,
      },
      {
        name: competitor2Name,
        flag: competitor2Flag,
      },
    ],
    scores: {
      main: {
        score: scores
          ? [MatchStateUtils.computeScore(scores, 0, 4), MatchStateUtils.computeScore(scores, 1, 4)]
          : ['', ''],
        isActive: scores ? scores.length < 5 : false,
      },
      secondaries: scores ? computeSecondaryScores(scores) : [],
    },
    expandThreshold: 2,
  };
};
